import React from "react";
import { useForm } from "@mantine/form";
import { Flex } from "@mantine/core";
import MantineTextInput from "../../../components/mantine/textinput";
import MantineButton from "../../../components/mantine/button";
import { onupdateManual } from "../../../store/manageSite/actions";

const EditManualUrl = (props: any) => {
  const { manualData, modalclose, dispatch, handleEdit, clientId } = props;

  const form = useForm({
    initialValues: {
      id: manualData?.id,
      url: manualData?.url || "",
      manualName: manualData?.manualName || "",
      siteId: manualData?.siteName || "",
      clientId: manualData?.clientName || "",
    },
    validate: {
      url: (value) => {
        const regex = new RegExp(
            /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/
        );
        return value  ? regex.test(value)  ? null : 'Please enter a valid URL'   : 'URL is required'; 
      },
      manualName: (value) => (value ? null : "Manual Name is required"),
      siteId: (value) => (value ? null : "Please select a Site"),
      clientId: (value) => (value ? null : "Please select a client"),
    },

  });
  const handleCancel = (event: React.MouseEvent) => {
    event.preventDefault(); 
    modalclose(); 
  };
  const changeManualUrl = () => {
    const data = {
      id: form.values.id,
      siteId: manualData.siteId,
      clientId: clientId,
      url: form.values.url,
      manualName: form.values.manualName,
    };
    dispatch(onupdateManual(data, handleEdit));
  };

  return (
    <form onSubmit={form.onSubmit(changeManualUrl)}>
      <MantineTextInput
        {...form.getInputProps("url")}
        required
        label="URL"
        classNames={{ input: "w-[400px] h-[40px] mb-4 bg-white border border-gray-400 rounded-full opacity-100 pr-10" }}
        error={form.errors.url}
      />
      <MantineTextInput
        required
        {...form.getInputProps("manualName")}
        label="Manual Name"
        onChange={(e: any) => form.setFieldValue('manualName', e.currentTarget.value)}
        classNames={{ input: "w-[400px] h-[40px] mb-4 bg-white border border-gray-400 rounded-full opacity-100 pr-10" }}
        error={form.errors.manualName}
      />    
      <MantineTextInput
         disabled={true}
        label="Site"
        placeholder="Select From Dropdown"
        
        {...form.getInputProps("siteId")}
        classNames={{ input: "w-[400px] h-[40px] mb-4 bg-white border border-gray-400 rounded-[40px]" }}
        //error={form.errors.url}
      />
      <MantineTextInput
        disabled={true}
        label="Client"
        placeholder="Select From Dropdown"
        
        {...form.getInputProps("clientId")}
        classNames={{ input: "w-[400px] h-[40px] mb-4 bg-white border border-gray-400 rounded-full" }}
        //error={form.errors.url}
      />    
      <Flex justify="flex-end">
        <MantineButton type="submit" className="mt-[15px] text-sm font-thin !w-[90px] mr-3">
          Save
        </MantineButton>
        <MantineButton
          className="bg-secondary_color hover:bg-hover_secondary_btn mt-[15px] text-sm font-thin !w-[100px]"
          onClick={handleCancel}
        >
          Cancel
        </MantineButton>
      </Flex>
    </form>
  );
};

export default EditManualUrl;
